import { SharedStoreDispatch } from '@squareup/dex-shell-main-shared';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { useDispatch } from 'react-redux';

type DispatchFunc = () => SharedStoreDispatch;
export const useSharedDispatch: DispatchFunc = useDispatch;
